import React from "react";

import Grid from "@material-ui/core/Grid";
import { DckSelectors, DckActionCreators } from "dck-redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "redux";

import { breadcrumbsFor } from "srx-shared";
import { ExpansionPanel } from "srx-shared/mui";

import { CostSavingsItem } from "@items/CostSavings";
import {
  TraditionalVmiOperationalCosts,
  SrxVmiOperationalCosts,
  DistributorInventory,
  SuggestedMinMaxFormula,
  OperationalCosts
} from "@items/types";
import { pages } from "@routes/pages";

import DistributorName from "../DistributorName";

const EXCLUDED_SECTIONS = ["supplyForce"];

const Breadcrumbs = breadcrumbsFor();

class CostSavingsComponent extends React.PureComponent {
  static propTypes = {
    getData: PropTypes.func,
    resetData: PropTypes.func,
    updateData: PropTypes.func,
    match: PropTypes.object
  };

  componentDidMount() {
    const {
      getData,
      resetData,
      match: {
        params: { id }
      }
    } = this.props;

    resetData(SrxVmiOperationalCosts);
    resetData(TraditionalVmiOperationalCosts);
    resetData(DistributorInventory);
    resetData(SuggestedMinMaxFormula);
    resetData(OperationalCosts);

    getData(SrxVmiOperationalCosts, id);
    getData(TraditionalVmiOperationalCosts, id);
    getData(DistributorInventory, id);
    getData(SuggestedMinMaxFormula, id);
    getData(OperationalCosts, id);
  }

  handleSubmit = (section, useDefault, data) => {
    const itemType = section.charAt(0).toUpperCase() + section.slice(1);
    const {
      match: {
        params: { id }
      }
    } = this.props;
    this.props.updateData(itemType, id, { ...data, useDefault });
  };

  renderSection = ({ title, section, Form }) => {
    const data = this.props[`${section}Data`];
    const updating = this.props[`${section}Updating`];
    if (!data) return null;

    return (
      <Grid key={section} item xs={12} style={{ maxWidth: 800 }}>
        <ExpansionPanel title={title} defaultExpanded>
          <Form
            data={data.currentValues}
            useDefaults={(data.currentValues || {}).useDefault}
            defaultValues={data.defaultValues}
            updating={updating}
            onSubmit={(data, useDefaults) =>
              this.handleSubmit(section, useDefaults, data)
            }
          />
        </ExpansionPanel>
      </Grid>
    );
  };

  breadcrumbsList = () => [
    { title: pages.distributors.title, to: pages.distributors.path },
    { title: <DistributorName /> },
    { title: "Cost Savings" }
  ];

  render() {
    const { sections, sectionsConfig } = CostSavingsItem;
    return (
      <div style={{ display: "flex", width: "100%", marginTop: 16 }}>
        <Breadcrumbs renderList={this.breadcrumbsList} />
        <Grid container spacing={2} justify="center">
          {sections
            .filter(section => !EXCLUDED_SECTIONS.includes(section))
            .map(section => this.renderSection(sectionsConfig[section]))}
        </Grid>
      </div>
    );
  }
}

const getSelector = state => itemType =>
  DckSelectors.getItemData(state, itemType, "data");

const getSelectorProcessRunning = state => itemType =>
  DckSelectors.selectProcessRunning(state, `${itemType.toUpperCase()}_UPDATE`);

const mapStateToProps = state => {
  const selector = getSelector(state);
  const selectorProcessRunning = getSelectorProcessRunning(state);
  return {
    srxVmiOperationalCostsData: selector(SrxVmiOperationalCosts),
    traditionalVmiOperationalCostsData: selector(
      TraditionalVmiOperationalCosts
    ),
    distributorInventoryData: selector(DistributorInventory),
    suggestedMinMaxFormulaData: selector(SuggestedMinMaxFormula),
    operationalCostsData: selector(OperationalCosts),
    srxVmiOperationalCostsUpdating: selectorProcessRunning(
      SrxVmiOperationalCosts
    ),
    traditionalVmiOperationalCostsUpdating: selectorProcessRunning(
      TraditionalVmiOperationalCosts
    ),
    distributorInventoryUpdating: selectorProcessRunning(DistributorInventory),
    suggestedMinMaxFormulaUpdating: selectorProcessRunning(
      SuggestedMinMaxFormula
    ),
    operationalCostsUpdating: selectorProcessRunning(OperationalCosts)
  };
};

const mapDispatchToProps = {
  getData: (itemType, id) => DckActionCreators.itemSelect(itemType, id),
  updateData: (itemType, id, data) =>
    DckActionCreators.itemSave(itemType, id, data),
  resetData: itemType => DckActionCreators.setItemData(itemType, "data", null)
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(CostSavingsComponent);
